export default {
	// 해당 프레임워크가 사용될 시스템 이름
	// 특정 타입 템플릿에서 상단에 출력됨
	name: 'giftshowBiz',
	// local 개발환경에서 작업 시, restful mockup 서버 url 정보
	// 차후, 개발 서버가 구축되면 그곳으로 변경
	devUrl: '/fo_api/', // web url
	// devUrl: 'http://192.168.111.232:8080/api', // IP

	// 서버 (개발, 운영) 환경에 build하여 업로드 할 경우, 기본 api base url
	buildUrlPanchok: '/fo_api_panchok/',
	buildUrl: '/fo_api/',
	framework: {
		// local 개발환경에서 작업 시, restful mockup 서버를 사용 여부
		// Server api가 없을 경우, json-server가 default
		// framework에서 제공되는 기본 셋에서만 적용 됨
		useRestfulMockup: true,
		// 빌드된 이후에도 mockup을 사용할 경우 true로 셋팅
		// useRestfulMockup 보다 더 상위. useRestfulMockup값이 true여도 이 값이 true 면 무시된다.
		onlyMockup: false,
		// framework에서는 지원하는 locale형식을 작성해야 한다.
		// 이 값을 각 Locale의 ID로 하며, 서버 조회 및 분기를 한다.
		supportLocales: [
			{
				id: 'ko',
				name: '한국어',
			},
			{
				id: 'en',
				name: 'English',
			},
		],
		// 기본 locale값을 지정한다. default는 Browser 기본이다.
		// 사용자가 직접 변경한 이후 부터는 local에 셋팅값이 저장되어 그 셋팅 값으로만 사용된다. (차후, localStorage로 저장되어 개인화 됨)
		locale: 'ko',
		// 서버에서 i18n 데이터를 가져와 적용할 것인가 설정하는 부분
		// true일 경우 서버를 조회하는 로직이 수행되고, false일 경우 서버를 조회하지 않고 local의 기본 값을 사용한다.
		getI18nDataFromServer: false,
		template: {
			// 테마 사용 시, 사용될 기본 값 (차후, localStorage로 저장되어 개인화 됨)
			pc: 'default',
			mobile: 'default',
			// mobile 테마를 사용할 여부. 사용하지 않으면 PC만 동작한다.
			useMobile: false,
			// 기본 화면으로 사용될 1depth 메뉴 ID
			home: 'dashboard',

			// 테마 리스트 정의
			pcThemes: [],
			mobileThemes: [],
		},
		// login 하지 않아도 접근이 가능한 URL 항목 리스트
		whiteList: [],
	},
};
